var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckIconSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2468 6.15838L8.28017 11.9167L6.69684 10.2251C6.40518 9.95005 5.94684 9.93338 5.61351 10.1667C5.28851 10.4084 5.19684 10.8334 5.39684 11.1751L7.27184 14.2251C7.45518 14.5084 7.77184 14.6834 8.13017 14.6834C8.47184 14.6834 8.79684 14.5084 8.98018 14.2251C9.28018 13.8334 15.0052 7.00838 15.0052 7.00838C15.7552 6.24172 14.8468 5.56672 14.2468 6.15005V6.15838Z",
    fill: "#717680"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIconSvg);
export default __webpack_public_path__ + "static/media/CheckIconSvg.976715182b4c38b7fbc4c17ce95a112d.svg";
export { ForwardRef as ReactComponent };